/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface AcknowledgeAlarmRequest
 */
export interface AcknowledgeAlarmRequest {
  /**
   *
   * @type {string}
   * @memberof AcknowledgeAlarmRequest
   */
  alarmId: string;
  /**
   *
   * @type {string}
   * @memberof AcknowledgeAlarmRequest
   */
  userEmail: string;
  /**
   *
   * @type {string}
   * @memberof AcknowledgeAlarmRequest
   */
  note?: string | null;
}

/**
 * Check if a given object implements the AcknowledgeAlarmRequest interface.
 */
export function instanceOfAcknowledgeAlarmRequest(
  value: object,
): value is AcknowledgeAlarmRequest {
  if (!("alarmId" in value) || value["alarmId"] === undefined) return false;
  if (!("userEmail" in value) || value["userEmail"] === undefined) return false;
  return true;
}

export function AcknowledgeAlarmRequestFromJSON(
  json: any,
): AcknowledgeAlarmRequest {
  return AcknowledgeAlarmRequestFromJSONTyped(json, false);
}

export function AcknowledgeAlarmRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AcknowledgeAlarmRequest {
  if (json == null) {
    return json;
  }
  return {
    alarmId: json["alarmId"],
    userEmail: json["userEmail"],
    note: json["note"] == null ? undefined : json["note"],
  };
}

export function AcknowledgeAlarmRequestToJSON(
  json: any,
): AcknowledgeAlarmRequest {
  return AcknowledgeAlarmRequestToJSONTyped(json, false);
}

export function AcknowledgeAlarmRequestToJSONTyped(
  value?: AcknowledgeAlarmRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    alarmId: value["alarmId"],
    userEmail: value["userEmail"],
    note: value["note"],
  };
}
